import React from 'react'

import Compare from 'components/CommonComparisons/components/Compare'
import Grid from 'components/Grid'
import Link from 'components/Link'
import Typography from 'components/Typography'
import { useEventContext } from 'context/EventContext'
import { updateBaseUrl } from 'helpers/bxApi'

import classes from './PopularComparisons.module.scss'

/** @type {import("./types").default} */
const PopularComparisons = ({ listing, comparisons, gridProps }) => {
  const eventContext = useEventContext({
    engagementComponent: 'product_comparisons',
  })
  return (
    <>
      <div className={classes.titleContainer}>
        <Typography component="h2" className={classes.title}>
          Popular comparisons with {listing.name}
        </Typography>
      </div>
      <Grid spacing={2} container>
        {comparisons.map(node => (
          <Grid
            {...eventContext.addEvent({
              name: 'engagement_cta_compare',
              engagementDetails: 'card_product-vs-product',
              engagementDestination: 'go-to_compare',
              compareProductUuids: `${listing.global_product_id}, ${node.id}`,
            })}
            component={Link}
            disableSeo={false}
            href={updateBaseUrl(node.url)}
            className={classes.link}
            item
            xs={12}
            sm={6}
            lg={4}
            key={node.id}
            {...gridProps}
          >
            <Compare className={classes.item} listings={[listing, { name: node.name, logo_url: node.logoUrl }]} />
          </Grid>
        ))}
      </Grid>
    </>
  )
}

export default PopularComparisons
